import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const lightandtraveleldConfig: TSPConfig = {
  key: 'lightandtraveleld',
  name: 'Light and Travel ELD',
  imageName: 'lightandtraveleld',
  category: TSPCategory.API_KEY,
  helpText: (
    <>
      <p>Connect to Light and Travel ELD by entering your API key.</p>
      <ol>
        <li>Log into your Light and Travel ELD dashboard</li>
        <li>Navigate to Settings → API Access</li>
        <li>Copy your API key</li>
        <li>Enter the API key below</li>
      </ol>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default lightandtraveleldConfig;
